<template>
  <div name="measuresChart" class="page rounded">

<section class=" w-95p mx-auto block px-2 py-4" >
                  <div class="text-center pt-2">
                      <i @click="move(0)"
                          class="fas fa-chevron-circle-left cursor-pointer text-4xl text-orange-300 hover:text-orange-400 float-left relative"></i> 
                            <i @click="move(1)"
                          class="fas fa-chevron-circle-right cursor-pointer text-4xl text-orange-300 hover:text-orange-400  float-right relative"></i>
                      <ul >
                 
              
                               <li>
                          <button 
                                  type="button"
                                  class="hover:bg-orange-400 hover:text-white font-bold py-1 px-3 rounded"
                                   v-bind:class="selectedView == 'week' ? 'bg-orange-300 text-white': 'bg-gray-100 text-gray-500 '"
                                 @click="selectedView = 'week'">
                                 Week
                                </button>
                              </li>
                        <li>
                           <button  
                                  type="button"
                                  class=" hover:bg-orange-400 hover:text-white font-bold py-1 px-3 mx-1 rounded"
                                   v-bind:class="selectedView == 'month' ? 'bg-orange-300 text-white': 'bg-gray-100 text-gray-500'"
                                  @click="selectedView = 'month'">
                                 Month
                                </button>
                              </li>
                               <li >
                            <button 
                                  type="button"
                                  class=" hover:bg-orange-400 hover:text-white font-bold py-1 px-3 rounded"
                                    v-bind:class="selectedView == 'year' ? 'bg-orange-300 text-white': 'bg-gray-100 text-gray-500'"
                                  @click="selectedView = 'year'">
                                 Year
                                </button>
                      </li>
                    </ul>


                        <h2 class="text-lg mt-6 text-gray-500">
                        
                          {{title}} 
                        
                        </h2>
                   </div>
         <barChart :data-source="measuresPlotted" v-if="componentLoaded" style="padding-bottom:30px; padding-top:30px;" ></barChart>
           <p v-else class="m-8 font-bold text-red-400 text-center">We could not find any data for your given selection.</p>
     
      </section>


  </div>
</template>

<script>
import moment from 'moment'

const barChart = () => import("@/components/charts/BarChart.vue");

export default {
  name: "measuresChart",
  props: ["measures"],
  computed: {
    componentLoaded() {
      return this.measures.length > 0;
    },
    title() {
      if (this.selectedView == 'year') {
        return "Monthly Steps " + this.selectedDate.year()
      } else if (this.selectedView == 'month') {
        return this.selectedDate.format("MMMM YYYY") + " Daily Steps"
      } else {
        return "Steps " 
        + this.selectedDate.clone().startOf('isoweek').format("D MMMM") 
        + " - " + this.selectedDate.clone().endOf('isoweek').format("D MMMM YYYY")
      }
    },
    measuresPlotted() {
      if (!this.componentLoaded) {
        return null;
      }

      if (this.selectedView == 'year') {
        return this.yearView
      } else if (this.selectedView == 'month') {
        return this.monthView
      } else {
        return this.weekView
      }
  },
  yearView() {
    let vm = this
      return vm.months.map(m => {
         var filtered = vm.measures.filter(measure => {
          let filtered = true;

          let date = moment(measure.measured_date, "YYYY-MM-DD");
          filtered = vm.selectedDate.year() === date.year() && m.value === date.month()

          return filtered;
        });

        return {
          name: m.label,
          value: filtered.reduce((a, b) => +a + +b.recorded_value, 0),
          color: '#DBF0F6'
        };
      });
    },
    monthView() {
        let vm = this

      return [...Array(vm.selectedDate.daysInMonth())].map((_, i) => {
         var filtered = vm.measures.filter(measure => {
          let filtered = true;

          let date = moment(measure.measured_date, "YYYY-MM-DD");
          filtered = vm.selectedDate.year() === date.year() && date.month() === vm.selectedDate.month() && i + 1 === date.date()

          return filtered;
        });

        return {
          name: i + 1,
          value: filtered.reduce((a, b) => +a + +b.recorded_value, 0),
          color: '#DBF0F6'
        };
      });
    },
  weekView() {
    let vm = this
    var weekStart = vm.selectedDate.clone().startOf('isoweek');
    var days = [];

      for (var i = 0; i <= 6; i++) {
          let d = moment(moment(weekStart).add(i, 'days'), "YYYY-MM-DD")
          days.push(d);
      }
    

      return days.map(d => {

         var filtered = vm.measures.filter(measure => {
          let filtered = true;

          let date = moment(measure.measured_date, "YYYY-MM-DD");
          filtered = d.isSame(date)
          return filtered;
        });

         let label  = moment(d, "YYYY-MM-DD")

        return {
          name: d.format("MMM D, dddd"),
          value: filtered.reduce((a, b) => +a + +b.recorded_value, 0),
          color: '#DBF0F6'
        };
      });
    },
  },
  data() {
    return {
      selectedDate: moment(),
      view: ['week', 'month', 'year'],
      selectedView: 'month',
        months: [{ label:'Jan', value: 0}, { label:'Feb', value: 1}, { label:'Mar', value: 2},{ label:'Apr', value: 3},
        { label:'May', value: 4}, { label:'Jun', value: 5}, { label:'Jul', value: 6}, { label:'Aug', value: 7},
        { label:'Sep', value: 8}, { label:'Oct', value: 9},{ label:'Nov', value: 10} , { label:'Dec', value: 11}],

    };
  },
  created() {},
  mounted() {},
  methods: {
    move(value) {
       if (this.selectedView == 'year') {
        this.selectedDate = value == 1 ? moment(this.selectedDate.add(1, 'y')) : moment(this.selectedDate.subtract(1, 'y'))
      } else if (this.selectedView == 'month') {
        this.selectedDate = value == 1 ? moment(this.selectedDate.add(1, 'months')) : moment(this.selectedDate.subtract(1, 'months'))
      } else {
        this.selectedDate = value == 1 ? moment(this.selectedDate.add(1, 'weeks')) : moment(this.selectedDate.subtract(1, 'weeks'))
      }
    }, 

  },
  components: {
    barChart
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

section li {
  display: inline-block; 
}
</style>
